import styled from "styled-components"

export const RatingContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.3rem;

  strong {
    font-weight: normal;
    padding-top: 0.3rem;
  }
`

export const RatingStars = styled.div`
  display: flex;

  & > * {
    width: 1.5rem;
    height: 1.6rem;
    margin-right: 1rem;
  }
`
